var _circle, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.6236,
    cy: 50.6999,
    r: 47.8602,
    fill: "#EAEEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.434 30.9499C115.698 30.9499 117.534 29.1142 117.534 26.8499C117.534 24.5855 115.698 22.7499 113.434 22.7499C111.169 22.7499 109.334 24.5855 109.334 26.8499C109.334 29.1142 111.169 30.9499 113.434 30.9499Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.434 14.9499C120.98 14.9499 122.234 13.6963 122.234 12.1499C122.234 10.6035 120.98 9.34985 119.434 9.34985C117.887 9.34985 116.634 10.6035 116.634 12.1499C116.634 13.6963 117.887 14.9499 119.434 14.9499Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4837 10.4C20.3556 10.4 22.6837 8.07189 22.6837 5.2C22.6837 2.32812 20.3556 0 17.4837 0C14.6118 0 12.2837 2.32812 12.2837 5.2C12.2837 8.07189 14.6118 10.4 17.4837 10.4Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1318 24.6253H52.637V14.9498H86.0568C86.1182 14.9498 86.1796 14.9498 86.2411 14.9498C91.4629 15.0731 95.7018 19.387 95.7018 24.6253H84.6438",
    fill: "#CCD4E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.9782 14.9498C85.0123 15.0731 83.1693 15.8742 81.8792 17.23C81.7563 17.3533 81.6335 17.4765 81.5106 17.6614C80.3433 19.0172 79.4833 20.8044 79.4833 22.7148V80.2744C79.4833 85.6359 75.1829 89.9498 69.8382 89.9498H22.9031V22.2834C23.0259 20.3114 23.7631 18.5242 25.0532 17.23C26.4662 15.8126 28.3707 14.9498 30.5208 14.9498H77.7631H86.7324C86.7939 14.9498 86.8553 14.9498 86.9782 14.9498Z",
    fill: "url(#paint0_linear)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1455 28.138H56.2001C55.7086 28.138 55.2786 27.7066 55.2786 27.2136C55.2786 26.7206 55.7086 26.2892 56.2001 26.2892H70.1455C70.6369 26.2892 71.067 26.7206 71.067 27.2136C71.067 27.7066 70.6984 28.138 70.1455 28.138Z",
    fill: "#B3BFD3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6267 28.138H31.4424C30.9509 28.138 30.5209 27.7066 30.5209 27.2136C30.5209 26.7206 30.9509 26.2892 31.4424 26.2892H49.6881C50.1796 26.2892 50.6096 26.7206 50.6096 27.2136C50.6096 27.7066 50.1796 28.138 49.6267 28.138Z",
    fill: "#B3BFD3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.299 37.2588H43.1761C42.6847 37.2588 42.2546 36.8275 42.2546 36.3344C42.2546 35.8414 42.6847 35.41 43.1761 35.41H61.299C61.7905 35.41 62.2205 35.8414 62.2205 36.3344C62.2819 36.8275 61.8519 37.2588 61.299 37.2588Z",
    fill: "#B3BFD3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.34 37.2588H31.4424C30.9509 37.2588 30.5209 36.8275 30.5209 36.3344C30.5209 35.8414 30.9509 35.41 31.4424 35.41H37.34C37.8315 35.41 38.2615 35.8414 38.2615 36.3344C38.2615 36.8275 37.8315 37.2588 37.34 37.2588Z",
    fill: "#D4DBEC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1455 46.3796H59.026C58.5345 46.3796 58.1045 45.9482 58.1045 45.4552C58.1045 44.9622 58.5345 44.5308 59.026 44.5308H70.1455C70.6369 44.5308 71.067 44.9622 71.067 45.4552C71.067 45.9482 70.6984 46.3796 70.1455 46.3796Z",
    fill: "#D4DBEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6813 46.3796H31.4424C30.9509 46.3796 30.5209 45.9482 30.5209 45.4552C30.5209 44.9622 30.9509 44.5308 31.4424 44.5308H53.6813C54.1728 44.5308 54.6028 44.9622 54.6028 45.4552C54.6028 45.9482 54.2342 46.3796 53.6813 46.3796Z",
    fill: "#B3BFD3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.299 55.5003H49.0737C48.5823 55.5003 48.1522 55.0689 48.1522 54.5759C48.1522 54.0829 48.5823 53.6515 49.0737 53.6515H61.299C61.7904 53.6515 62.2205 54.0829 62.2205 54.5759C62.2819 55.0689 61.8519 55.5003 61.299 55.5003Z",
    fill: "#B3BFD3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7291 55.5003H31.4424C30.9509 55.5003 30.5209 55.0689 30.5209 54.5759C30.5209 54.0829 30.9509 53.6515 31.4424 53.6515H43.7905C44.282 53.6515 44.712 54.0829 44.712 54.5759C44.712 55.0689 44.282 55.5003 43.7291 55.5003Z",
    fill: "#D4DBEC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1454 64.6212H61.6062C61.1147 64.6212 60.6847 64.1898 60.6847 63.6967C60.6847 63.2037 61.1147 62.7723 61.6062 62.7723H70.1454C70.6369 62.7723 71.0669 63.2037 71.0669 63.6967C71.0669 64.1898 70.6983 64.6212 70.1454 64.6212Z",
    fill: "#B3BFD3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0772 64.6212H41.7632C41.2717 64.6212 40.8417 64.1898 40.8417 63.6967C40.8417 63.2037 41.2717 62.7723 41.7632 62.7723H56.0772C56.5686 62.7723 56.9987 63.2037 56.9987 63.6967C56.9987 64.1898 56.5686 64.6212 56.0772 64.6212Z",
    fill: "#D4DBEC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4185 64.6212H31.4424C30.9509 64.6212 30.5209 64.1898 30.5209 63.6967C30.5209 63.2037 30.9509 62.7723 31.4424 62.7723H36.4185C36.91 62.7723 37.34 63.2037 37.34 63.6967C37.34 64.1898 36.91 64.6212 36.4185 64.6212Z",
    fill: "#B3BFD3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.299 73.7419H52.8212C52.3297 73.7419 51.8997 73.3105 51.8997 72.8175C51.8997 72.3245 52.3297 71.8931 52.8212 71.8931H61.299C61.7904 71.8931 62.2205 72.3245 62.2205 72.8175C62.2819 73.3105 61.8519 73.7419 61.299 73.7419Z",
    fill: "#B3BFD3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2308 73.7419H31.4424C30.9509 73.7419 30.5209 73.3105 30.5209 72.8175C30.5209 72.3245 30.9509 71.8931 31.4424 71.8931H47.2308C47.7222 71.8931 48.1523 72.3245 48.1523 72.8175C48.1523 73.3105 47.7222 73.7419 47.2308 73.7419Z",
    fill: "#D4DBEC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1966 82.3081H61.6062C61.6062 84.4034 62.4663 86.3139 63.8178 87.6697C65.1693 89.0871 67.0738 89.8882 69.1625 89.8882H13.3195C11.2308 89.8882 9.32632 89.0255 7.97479 87.6697C6.62325 86.3139 5.76318 84.4034 5.76318 82.3081H42.5004C42.5004 82.3081 49.3195 82.3697 49.1966 82.3081Z",
    fill: "#CCD4E2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.471 76.4062L94.7145 68.6556L96.4927 66.8774L104.243 74.6341L102.471 76.4062Z",
    fill: "#858B9B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.167 79.1332L99.2197 73.1854C98.723 72.6887 98.723 71.8793 99.2197 71.3826C99.7163 70.886 100.526 70.886 101.022 71.3826L106.97 77.3304C107.467 77.8271 107.467 78.6365 106.97 79.1332C106.474 79.6298 105.664 79.6298 105.167 79.1332Z",
    fill: "#858B9B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.744 79.5133L97.092 71.8609C96.9142 71.6831 96.9142 71.3949 97.092 71.211L99.048 69.2549C99.2258 69.0771 99.514 69.0771 99.698 69.2549L107.35 76.9074C107.528 77.0852 107.528 77.3734 107.35 77.5573L105.394 79.5133C105.21 79.6912 104.922 79.6912 104.744 79.5133Z",
    fill: "url(#paint1_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9339 43.681C77.8154 43.681 71.2361 50.2604 71.2361 58.3788C71.2361 66.4911 77.8154 73.0766 85.9277 73.0766C94.0461 73.0766 100.625 66.4972 100.625 58.3788C100.625 50.2604 94.0461 43.681 85.9339 43.681ZM85.9339 70.3541C79.4158 70.3541 74.1364 64.9888 74.1364 58.3727C74.1364 51.7565 79.4158 46.3974 85.9339 46.3974C92.4519 46.3974 97.7313 51.7627 97.7313 58.3788C97.7313 64.9949 92.4458 70.3541 85.9339 70.3541Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.903076,
    y: 3.94983,
    width: 108.075,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 54.9197,
    y1: 13.215,
    x2: 54.9197,
    y2: 90.7584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 96.9538,
    y1: 74.3853,
    x2: 107.486,
    y2: 74.3853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 71.2226,
    y1: 58.382,
    x2: 100.631,
    y2: 58.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search_icon.905f1034.svg";
export { ForwardRef as ReactComponent };